import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollReset from "./chrome/ScrollReset";
import Home from "./views/Home";
import Services from "./views/Services";
import Service from "./views/Service";
import About from "./views/About";
import Markets from "./views/Markets";
import Contact from "./views/Contact";
import NotFound from "./views/NotFound";

const App = () => (
  <ScrollReset>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<Service />} />
      <Route path="/markets" element={<Markets />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ScrollReset>
);

export default App;
